// Vehicle-Specific Attributes — injects DataGate `vehicleSpecificAttributes` for
// the customer's SELECTED vehicle into the storefront product Specifications
// table. The selected vehicle's car_ids are shared from the parts-finder via
// localStorage ('pf.vehicleCarIds', written only when a FULL variant is selected).
//
// Renders NOTHING when no vehicle is selected or the product has no matching
// attributes. Mount (first hit wins):
//   [data-parts-vehicle-attributes]  — explicit container, OR
//   #productdetails                   — the core Specifications tab pane (enhanced)
// SKU source: the mount's data-sku, then data-sku-selector / #product-sku.

import { getTopDocument, esc, getSku as resolveSku } from '../shared/dom.js';
import { apiFetch } from '../shared/api.js';

function getSelectedCarIds() {
	function parse(raw) {
		if (!raw) return [];
		try {
			var arr = JSON.parse(raw);
			return Array.isArray(arr) ? arr.filter(function (n) { return typeof n === 'number' && n > 0; }) : [];
		} catch (e) { return []; }
	}
	try { return parse((window.top || window).localStorage.getItem('pf.vehicleCarIds')); }
	catch (e) { try { return parse(localStorage.getItem('pf.vehicleCarIds')); } catch (e2) { return []; } }
}

function findMount(doc) {
	return doc.querySelector('[data-parts-vehicle-attributes]') || doc.getElementById('productdetails');
}

function getSku(mount) {
	var direct = mount && mount.getAttribute && mount.getAttribute('data-sku');
	if (direct && direct.trim()) return direct.trim();
	return resolveSku((mount && mount.getAttribute && mount.getAttribute('data-sku-selector')) || '#product-sku');
}

// Filter to the active car_ids and group by attribute name (unique values joined).
function groupRows(list, carIds) {
	var active = {};
	carIds.forEach(function (id) { active[id] = true; });
	var byName = {};
	var order = [];
	for (var i = 0; i < list.length; i++) {
		var a = list[i];
		if (!a || !active[a.carId]) continue;
		var name = (a.attributeName || '').trim();
		var val = (a.attributeValue || '').trim();
		if (!name && !val) continue;
		if (!byName[name]) { byName[name] = {}; order.push(name); }
		if (val) byName[name][val] = true;
	}
	return order.sort().map(function (name) { return { name: name, value: Object.keys(byName[name]).join(', ') }; });
}

function render(mount, rows) {
	var doc = mount.ownerDocument || document;
	// Clear any prior injection (SKU / vehicle may have changed).
	var prev = mount.querySelector('.pfva-wrap');
	if (prev && prev.parentNode) prev.parentNode.removeChild(prev);
	if (!rows.length) return;
	var carSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><path d="M9 17h6"/><circle cx="17" cy="17" r="2"/></svg>';
	var h = '<div class="pfva-wrap"><p class="pfva-head">' + carSvg + 'For your selected vehicle</p><table class="pfva-table"><tbody>';
	rows.forEach(function (r) { h += '<tr><th>' + esc(r.name) + '</th><td>' + esc(r.value) + '</td></tr>'; });
	h += '</tbody></table></div>';
	// Prepend so the vehicle-specific rows sit ABOVE the general specifications.
	mount.insertAdjacentHTML('afterbegin', h);
}

export function init() {
	var doc = getTopDocument();
	var mount = findMount(doc);
	if (!mount) return; // no specifications pane on this page

	var carIds = getSelectedCarIds();
	if (!carIds.length) return; // no vehicle selected → show nothing

	var sku = getSku(mount);
	if (!sku) return;

	apiFetch('/api/parts/' + encodeURIComponent(sku))
		.then(function (r) { return r.ok ? r.json() : null; })
		.then(function (part) {
			if (!part || !Array.isArray(part.vehicleSpecificAttributes)) return;
			render(mount, groupRows(part.vehicleSpecificAttributes, carIds));
		})
		.catch(function () { /* non-critical */ });
}

export var id = 'vehicle-attributes';
